export default "__VITE_ASSET__BwE3uk8D__"